import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './PaymentResult.css';

const Failure = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // URL'den hata mesajını al (Örn: ?msg=Bakiye_Yetersiz)
  const errorMsg = searchParams.get('msg') || 'Bilinmeyen bir hata oluştu.';
  
  // Hata kodlarını daha anlaşılır metinlere çevirelim
  const getUserFriendlyMessage = (msg) => {
    if (msg.includes('Bakiye')) return 'Kartınızda yeterli bakiye bulunmamaktadır.';
    if (msg.includes('zaman_asimi')) return 'İşlem zaman aşımına uğradı. Lütfen tekrar deneyin.';
    if (msg.includes('3d')) return '3D Güvenlik doğrulaması yapılamadı.';
    if (msg.includes('iptal')) return 'İşlem tarafınızca iptal edildi.';
    return decodeURIComponent(msg); // Diğer hataları olduğu gibi göster
  };

  return (
    <div className="payment-container">
      <div className="card failure">
        <div className="icon-box">
          ✕
        </div>
        <h1 className="title">Ödeme Başarısız</h1>
        <p className="message">
          Maalesef ödeme işlemi tamamlanamadı.
          <br />
          <strong>Sebep:</strong> {getUserFriendlyMessage(errorMsg)}
        </p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
          <button className="btn btn-failure" onClick={() => navigate('/SatinAl')}>
            Tekrar Dene
          </button>
          <button className="btn" style={{background:'#eee', color:'#333'}} onClick={() => navigate('/')}>
            Anasayfa
          </button>
        </div>
      </div>
    </div>
  );
};

export default Failure;
